import React, { Fragment,useCallback } from "react";
import { useDispatch } from "react-redux";
import { translate } from "../Services/translation";
import { onHandNumberFormatWithoutDecimal } from "../Services/formatting";
import onhandCheckLogic from "../Services/onhandcheck";
import onhandcheckLanguage from "../Services/onhandcheckLanguage";
import onhandcheckleadTimeLanguage from "../Services/onhandcheckleadTimeLanguage";
import NotifyButton from "./NotifyButton";
import { setNotifyEmailWhenInStock } from "../Actions/Product.action";
import moment from "moment";

const ConfigStock = (props) => {
  const artList = props.articleStock["articlesList"] != null ? props.articleStock["articlesList"] : null;
  const articleweight = props["articleweight"] != undefined ? props["articleweight"] : 0;
  const articleFactorKg = props["articleFactorKg"] != undefined ? props["articleFactorKg"] : 0;
  const isauthendicated = props["isauthorized"] != undefined ? props["isauthorized"] : true;
  let stockArticle = props.articleStock ? (artList ? artList.find((x) => x.variantSystemId === props.id) : null) : null;
  const loginUrl = props["loginUrl"] != undefined ? props["loginUrl"] : null;
  const showItem = props["showItem"] != undefined ? (props["showItem"] == "1" ? true : false) : false;
  const becomeCustomer = props["becomeCustomer"] != undefined ? props["becomeCustomer"] : null;
  const dispatch = useDispatch();

  const addStockNotify = useCallback(
    (systemId) => {
      dispatch(setNotifyEmailWhenInStock(systemId));
    },
    [dispatch]
  );

  let deliveryWeek = stockArticle ? moment(new Date(stockArticle.nextIncomingDate)).isoWeeks() : null;
  var currentWeek = moment().locale(window.__litium.constants.currentLocale).isoWeeks();
  let isSameYear = stockArticle ? moment(new Date(stockArticle.nextIncomingDate)).isSame(moment().locale(window.__litium.constants.currentLocale), "year") : false;
  let originWarehouse = stockArticle ? stockArticle.originWarehouse : '';  

  if (deliveryWeek && isSameYear && deliveryWeek < currentWeek) {
    const { estimatedDeliveryWeek } = window.__litium.channelConfig;
    deliveryWeek = currentWeek + estimatedDeliveryWeek;
  }
  {
    {
      return (
        <Fragment>
          {isauthendicated == false ? (
            <div className="stock-outer">
            <div className="stock-details">
                  {loginUrl && (
                    <a href={loginUrl} className="stock__weight--nobold">
                      {translate('configstock.instock')}
                    </a>
                  )}
                  {!showItem && becomeCustomer && (
                    <a
                      href={becomeCustomer}
                      className="button button--orange--customer product-name-desktop"
                    >
                      {translate('configstock.becomecustomer')}
                    </a>
                  )}
            </div>
          </div>
          ) : (
            <Fragment>
              {stockArticle ? (
                <div className="stock-outer">
                  <div className="stock-details">
                    {/* FirstCase Starts */}
                    {stockArticle.quantity > 0 && stockArticle.nextIncomingQuantity > 0 && (
                      <Fragment>
                        <div className={onhandCheckLogic(stockArticle.inventoryUnit, articleFactorKg, stockArticle.quantity, articleweight) ? "stock__weight" : "stock__incoming"}>
                          {onhandCheckLogic(stockArticle.inventoryUnit, articleFactorKg, stockArticle.quantity, articleweight) && (
                            <svg>
                              <use href="/ui/images/sprites/be-group.svg#attention"></use>
                            </svg>
                          )}
                          {stockArticle.quantity > 10 ? onHandNumberFormatWithoutDecimal.format(stockArticle.quantity) : stockArticle.quantity} {translate("orderrow." + stockArticle.inventoryUnit)} {originWarehouse}
                        </div>
                        {onhandCheckLogic(stockArticle.inventoryUnit, articleFactorKg, stockArticle.quantity, articleweight) && (
                            <span>{translate("orderrow.lowstock.notification")}</span> 
                          )}
                        <div className="stock__incoming">
                          <span className="incoming__weight">
                            <svg>
                              <use href="/ui/images/sprites/be-group.svg#delivery-truck"></use>
                            </svg>

                            <span>
                              {onHandNumberFormatWithoutDecimal.format(stockArticle.nextIncomingQuantity)} {translate("orderrow." + stockArticle.inventoryUnit)}
                            </span>
                          </span>
                          <span className="incoming__date">
                            {moment(new Date(stockArticle.nextIncomingDate)).format("YYYY")} {translate("moment.weeknumber")}
                            {deliveryWeek}
                          </span>
                          <span className="incoming__weight incoming__weight--data">
                            <span className="data-tooltip" data-tip={stockArticle.nextIncomeDateToolTip} data-html="true">
                              <svg>
                                <use href="/ui/images/sprites/be-group.svg#attention-i"></use>
                              </svg>
                            </span>
                          </span>
                        </div>
                      </Fragment>
                    )}
                    {/* FirstCase Ends */}
                    {/* SecondCase Starts */}
                    {stockArticle.quantity > 0 && stockArticle.nextIncomingQuantity <= 0 && (
                      <Fragment>
                        <div className={onhandCheckLogic(stockArticle.inventoryUnit, articleFactorKg, stockArticle.quantity, articleweight) ? "stock__weight" : "stock__weight--nobold"}>
                          {onhandCheckLogic(stockArticle.inventoryUnit, articleFactorKg, stockArticle.quantity, articleweight) && (
                            <svg>
                              <use href="/ui/images/sprites/be-group.svg#attention"></use>
                            </svg>
                          )}
                          {stockArticle.quantity > 10 ? onHandNumberFormatWithoutDecimal.format(stockArticle.quantity) : stockArticle.quantity} {translate("orderrow." + stockArticle.inventoryUnit)} {originWarehouse}
                        </div>
                        {onhandCheckLogic(stockArticle.inventoryUnit, articleFactorKg, stockArticle.quantity, articleweight) && ( 
                          <span>{translate("orderrow.lowstock.notification")}</span> 
                        )}
                      </Fragment>
                    )}
                    {/* SecondCase Ends */}
                    {/* ThirdCaseStarts */}
                    {stockArticle.quantity <= 0 && stockArticle.nextIncomingQuantity > 0 && (
                      <Fragment>
                        <div className="stock__weight">
                        {onhandCheckLogic(stockArticle.inventoryUnit, articleFactorKg, stockArticle.quantity, articleweight) && (
                            <svg>
                              <use href="/ui/images/sprites/be-group.svg#attention"></use>
                            </svg>
                          )}
                          0 {translate("orderrow." + stockArticle.inventoryUnit)}
                        </div>
                        <Fragment>
                          <div>{articleweight > 0 && translate("orderrow.lowstock.notification")}</div> 
                          <NotifyButton productId={props.id} addStockNotify={addStockNotify} isStockNotify={stockArticle.isStockNotify} />
                        </Fragment>
                        <div className="stock__incoming">
                          <span className="incoming__weight">
                            <svg>
                              <use href="/ui/images/sprites/be-group.svg#delivery-truck"></use>
                            </svg>
                            <span>
                              {onHandNumberFormatWithoutDecimal.format(stockArticle.nextIncomingQuantity)} {translate("orderrow." + stockArticle.inventoryUnit)}
                            </span>
                          </span>
                          <span className="incoming__date">
                            {moment(new Date(stockArticle.nextIncomingDate)).format("YYYY")} {translate("moment.weeknumber")}
                            {deliveryWeek}
                          </span>
                          <span className="incoming__weight incoming__weight--data">
                            {/* data-original-title={stockArticle.nextIncomeDateToolTip}  */}
                            <span className="data-tooltip" data-tip={stockArticle.nextIncomeDateToolTip} data-html="true">
                              <svg>
                                <use href="/ui/images/sprites/be-group.svg#attention-i"></use>
                              </svg>
                            </span>
                          </span>
                        </div>
                      </Fragment>
                    )}
                    {/* ThirdCase Ends */}
                    {/* Fourth Case Starts */}
                    {stockArticle.quantity <= 0 && stockArticle.nextIncomingQuantity <= 0 && stockArticle.leadtimeVendor > 0 && (
                      <Fragment>
                        <div className="stock__weight--nobold">
                          {/* {translate("configstock.leadtime")} {stockArticle.leadtimeVendor} {translate("configstock.leadtimedays")} */}
                          {onhandcheckleadTimeLanguage("configstock.leadtime.loginuser", stockArticle.leadtimeVendor, "configstock.leadtimedays")}
                        </div>
                      </Fragment>
                    )}
                    {/* Fourth Case Ends */}
                    {/* FifthCase Starts */}
                    {stockArticle.quantity <= 0 && stockArticle.nextIncomingQuantity <= 0 && stockArticle.leadtimeVendor <= 0 && (
                      <Fragment>
                        <div className="stock__weight--nobold">{translate("configstock.contactbe")}</div>
                      </Fragment>
                    )}

                    {/* FifthCase Ends */}
                  </div>
                </div>
              ) : (
                <div className="skeleton skeleton--loading">
                  <div className="skeleton__waiting">
                    <div className="skeleton__header w100 stock-sec">
                      <div className="comment-sec">
                        <div className="skeleton-text comment animate w40"></div>
                        <div className="skeleton-text comment animate"></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Fragment>
          )}
        </Fragment>
      );
    }
  }
};
export default ConfigStock;
